// extracted by mini-css-extract-plugin
export default {"JobStatusDropdown":"styles_JobStatusDropdown__70o4t","selector":"styles_selector__5sLjX","notActive":"styles_notActive__DYame","options":"styles_options__DaqD-"};